exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-header[data-v-05aa6a72]{padding:0;border-bottom:none}.circular[data-v-05aa6a72]{display:inline-block;width:6px;height:6px;border-radius:50%;margin-top:-2px;margin-right:5px}[data-v-05aa6a72] .el-form-item{margin-right:10px}.table-box[data-v-05aa6a72] .el-table th{background-color:#f7fbff}.page-fixed[data-v-05aa6a72]{bottom:0px}\n", ""]);

// exports
